import { createAction } from '@reduxjs/toolkit';
import { FetchOrganizationRecipients } from './organization-recipient.types';

export const fetchOrganizationRecipientRequested = createAction<FetchOrganizationRecipients>(
  'ORG_RECIPIENT/FETCH_ORG_RECIPIENT_API_REQUESTED'
);
export const fetchOrganizationRecipientSuccess = createAction<string[]>('ORG_RECIPIENT/FETCH_ORG_RECIPIENT_API_SUCCESS');
export const fetchOrganizationRecipientFailed = createAction<string[]>('ORG_RECIPIENT/FETCH_ORG_RECIPIENT_API_FAILED');
